import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PiAirplaneTakeoffFill } from "react-icons/pi";
import { PiAirplaneLandingFill } from "react-icons/pi";
import Card from "react-bootstrap/Card";
import { FaCalendarAlt } from "react-icons/fa";
import { BsFillSuitcase2Fill } from "react-icons/bs";
import { IoIosSettings } from "react-icons/io";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, InputGroup } from "react-bootstrap";
import { ImAddressBook } from "react-icons/im";
import { IoSettingsSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { endPoints, Image_Url } from "../../Constant/Environment";
import { addItemToken, getAllItemsData, getAllItemsToken } from "../../Utility/Api";
import Toaster from "../Toast/index";
import Loader from "../Loader/index";
import axios from "axios";
import { formatDate, formatDateByMonth } from "../../Utility/AxiosInstance";
import { FaRegEdit } from "react-icons/fa";
import { Actions } from "../../redux/Actions/Actions";
import swal from 'sweetalert';
import { ErrorToast } from "../Toast/message";
import CitySelector from "../CitySelector/CitySelector";
import { RxDoubleArrowDown } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { useSelector, useDispatch } from "react-redux";
import { Country, State, City } from 'country-state-city';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';



function DashboardTraveler({ traveler, travelerInfoData, token }) {
  const cityList = (City.getAllCities());


  const [editData, setEditData] = useState({});
  const [senderAndTravelerInfo, setSenderAndTravelerInfo] = useState(travelerInfoData);
  let navigate = useNavigate();
  const [to_state_name, setToStateName] = useState("");
  const [to_country_name, setTocountryName] = useState("");
  const [from_country_name, setFromcountryName] = useState("");
  const [from_state_name, setFromStateName] = useState("");
  // console.log(traveler);
  const [profilepic, setProfilepic] = useState(null);
  const travelerId = traveler._id;
  const [fromWhere, setFromWhere] = useState("");
  const [toWhere, setToWhere] = useState("");
  const [travel_date, setFlightDate] = useState("");
  const [maxWeight, setMaxWeight] = useState("");
  const [password, setpassword] = useState("");
  const [confirm_password, setConfirmpassword] = useState("");
  const dispatch = useDispatch();
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoadinig] = useState(false);

  const [itemsToShow, setItemsToShow] = useState(4);

  const handleLoadMore = () => {
    setItemsToShow(itemsToShow + 3);
  };
  const handlePasswordSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      password: password,
      confirm_password: confirm_password,
      email: traveler ? traveler.email : '',
    };
    if (password && confirm_password) {
      if (password != confirm_password) {
        swal('Error!', "Password does not match.", 'error');
        return;
      }
      try {
        let url = `${endPoints.api.CHANGE_PASSWORD}`;
        setIsLoadinig(true);
        const response = await addItemToken(url, payload);
        if (response.status === 200) {
          setTimeout(function () {
            GetUserById();
            setpassword("");
            setConfirmpassword("");
            setIsLoadinig(false);
            swal('Success!', "Password change successfully.", 'success');
          }, 1000);

        }
      } catch (error) {
        if (error.response.data.status === 401) {
          dispatch({
            type: Actions.USERLOGOUT,
          });
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");
        } else {
          setIsLoadinig(false);
          ErrorToast(error.response.data.message);
          console.error(error);
        }
      }
    } else {
      setIsLoadinig(false);
      ErrorToast("All fields are required");
    }
    // console.log(payload)
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      travelerId: travelerId,
      fromWhere: fromWhere,
      toWhere: toWhere,
      travel_date: travel_date,
      maxWeight: maxWeight,
      from_country_name: from_country_name,
      from_state_name: from_state_name,
      to_country_name: to_country_name,
      to_state_name: to_state_name,

    };

    if (fromWhere && toWhere && travel_date && maxWeight && fromWhere !== toWhere) {

      try {
        let url = editData?._id
          ? `${endPoints.api.UpdateTravelerInfo}`
          : `${endPoints.api.AddTravelerInfo}`;

        setIsLoadinig(true);
        if (editData?._id) {
          payload._id = editData._id;
        }
        const response = await addItemToken(url, payload);
        if (response.status === 200) {

          setTimeout(function () {
            GetUserById();
            setFromWhere("");
            setToWhere("");
            setFlightDate("");
            setMaxWeight("");
            setFromStateName("");
            setFromcountryName("");
            setTocountryName("");
            setToStateName("");
            setIsLoadinig(false);
            setEditData("");
            swal('Success!', "Information updated successfully.", 'success');
          }, 1000);

        }
      } catch (error) {
        if (error.response.data.status === 401) {
          dispatch({
            type: Actions.USERLOGOUT,
          });
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");
        } else {
          setIsLoadinig(false);
          ErrorToast(error.response.data.message);
          console.error(error);
        }
      }
    } else {
      setIsLoadinig(false);
      ErrorToast("All fields are required");
    }
  };


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [])

  useEffect(() => {
    if (Object.keys(editData).length != 0) {
      // console.log(editData)
      setFromWhere(editData.fromWhere || '');
      setToWhere(editData.toWhere || '');
      setMaxWeight(editData.maxWeight || '');
      setToStateName(editData.to_state_name || '');
      setTocountryName(editData.to_country_name || '');
      setFromStateName(editData.from_state_name || '');
      setFromcountryName(editData.from_country_name || '');
      setFlightDate(moment(editData?.travel_date).format("YYYY-MM-DD"));
    } else {
      setFromWhere("");
      setToWhere("");
      setMaxWeight("");
      setFlightDate("");
      setFromStateName("");
      setFromcountryName("");
      setTocountryName("");
      setToStateName("");
    }
  }, [editData]);

  const onImageChange = (event) => {
    const { files } = event.target;

    if (!files[0]?.name.match(/\.(jpg|jpeg|png|gif)$/)) {
      ErrorToast('Please select a valid image.');
      return;
    }

    const MAX_FILE_SIZE = 1024; // 1MB
    const fileSizeKiloBytes = files[0]?.size / MAX_FILE_SIZE;

    if (fileSizeKiloBytes > 2048) {
      ErrorToast('File size is greater than 2MB. Please upload again.');
      return;
    }

    const url = URL.createObjectURL(files[0]);

    setProfilepic(url);
    UploadImage(files[0]);
  };
  const storedAuthState = JSON.parse(localStorage.getItem("authState"));
  const UploadImage = async (file) => {
    try {
      setIsLoadinig(true);
      var formdata = new FormData();
      const url = `${endPoints.api.UPDATE_PROFILE_IMAGE}` + '/' + travelerId;
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
        'Authorization': storedAuthState.token,
      };
      formdata.append('image', file);
      const response = await axios.post(endPoints.apiBaseUrl + url, formdata, { headers: headers });
      if (response.status === 200) {

        setTimeout(function () {
          setIsLoadinig(false);
          GetUserById();
          swal('Success!', "Profile uploaded successfully.", 'success');
        }, 5000);
      }

    } catch (error) {
      if (error.response.data.status === 401) {
        dispatch({
          type: Actions.USERLOGOUT,
        });
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
      } else {
        setIsLoadinig(false);
        console.error('Error:', error);
      }

    }
  };

  const GetUserById = () => {
    let url = `${endPoints.api.GETBYTRAVELERID}/${travelerId}`;
    getAllItemsToken(url).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        console.log(response);
        setSenderAndTravelerInfo(response.final_data.travelerInfoData);
        dispatch({
          type: Actions.USERLOGIN,
          data: {
            user: response.final_data.users,
            travelerInfo: response.final_data.travelerInfoData,
            token: storedAuthState.token
          },
        });
      }
      // getAllData();
    });
  };

  const getStateName = (locationName) => {
    const matchingCity = City.getAllCities().find(item =>
      item.name === locationName
    );

    var finalData = {};
    if (matchingCity) {
      const getStatesByCountry = State.getStatesOfCountry(matchingCity.countryCode);
      const allStates = State.getAllStates();
      finalData = getStatesByCountry.find(state =>
        state.isoCode === matchingCity.stateCode
      );
    } else {
      console.log('No matching city found');
    }

    return finalData ? (
      <>
        {finalData.name}
      </>
    ) : null;
  };
  // console.log(senderAndTravelerInfo)
  return (
    <>
      <section className="sec-padd middle">
        <Container>
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">

            <Row className=" g-5 dashboard-page">
              <Col md={4}>
                <div className="bg-white">

                  <div className="card1 mb-4">

                    <Card.Img
                      variant="top"
                      src={
                        profilepic
                          ? profilepic
                          : !traveler.image
                            ? require(`../../Assets/Images/${traveler && traveler.gender === 'male' ? 'male-user' : 'female'}.png`)
                            : (Image_Url + traveler.image).replace(/\\/g, '/')
                      }
                      alt={traveler && traveler.gender === 'male' ? 'Male' : 'Female'}
                    />


                    <label htmlFor="imageUpload" className="imageUpload">
                      <p> <FaRegEdit /> Edit Avatar</p>
                    </label>
                    <input
                      type="file"
                      id="imageUpload"
                      style={{ display: 'none' }}
                      onChange={onImageChange}
                      accept=".jpg, .jpeg, .png, .gif"
                    />
                    <h6>{traveler.first_name}</h6>
                  </div>
                  <div className="pb-5 pt-3 px-4">

                    <Nav variant="pills" className="flex-column">
                      <Nav.Item>
                        <Nav.Link eventKey="first" className="subs">Change Password</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second" className="subs">Upcoming List</Nav.Link>
                      </Nav.Item>
                    </Nav>


                  </div>
                </div>
              </Col>
              <Col md={8}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <Col md={12}>
                      <div className="bgwhite">
                        <h3 className="c-heading text-center hdmrgn">
                          Change Password
                        </h3>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <Toaster></Toaster>
                        </div>
                        <Form className="mb-5 Reative" validated={validated}
                          onSubmit={handlePasswordSubmit}  >
                          {isLoading && <Loader spinner={true} visible={isLoading} className="LoaderForm" />}

                          <Row className="align-items-center justify-content-center">
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                New Password
                              </div>
                            </Col>
                            <Col sm={9}>
                              <Form.Group controlId="formBasicEmail">
                                <Form.Control className="form-set" type="password" placeholder="Enter New Password" value={password}
                                  onChange={(e) => setpassword(e.target.value)} />
                              </Form.Group>
                            </Col>
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                New Confirm Password
                              </div>
                            </Col>
                            <Col sm={9}>
                              <Form.Group controlId="formBasicEmail">
                                <Form.Control type="password" placeholder="Enter New Confirm Password" value={confirm_password}
                                  onChange={(e) => setConfirmpassword(e.target.value)} />
                              </Form.Group>
                            </Col>

                          </Row>
                          <Row className="justify-content-center">
                            <Col xs={3}>
                              <Button className="last-btn c-btn mt-5" type="submit"
                                onClick={handlePasswordSubmit}
                              >
                                Save
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <Col md={12}>
                      <div className="bgwhite">
                        <h3 className="c-heading text-center hdmrgn">
                          From Where, To Where And When Do You Go
                        </h3>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <Toaster></Toaster>
                        </div>
                        <Form className="mb-5 Reative" validated={validated}
                          onSubmit={handleSubmit}  >
                          {isLoading && <Loader spinner={true} visible={isLoading} className="LoaderForm" />}

                          <Row className="align-items-center justify-content-center">
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                <PiAirplaneTakeoffFill />
                                From where*
                              </div>
                            </Col>
                            <Col sm={9}>
                              <Form.Group className="mb-3" controlId="formBasicEmail">
                                <CitySelector
                                  DepartureCity={fromWhere}
                                  setDepartureCity={setFromWhere}
                                  setcountryName={setFromcountryName}
                                  setStateName={setFromStateName}
                                // setcityName={setcityName}
                                />

                              </Form.Group>
                            </Col>
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                <PiAirplaneLandingFill />
                                To where*
                              </div>
                            </Col>
                            <Col sm={9}>
                              <Form.Group className="mb-3" controlId="formBasicEmail">
                                <CitySelector
                                  DepartureCity={toWhere}
                                  setDepartureCity={setToWhere}
                                  setcountryName={setTocountryName}
                                  setStateName={setToStateName}
                                // setcityName={setcityName}
                                />

                              </Form.Group>
                            </Col>
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                <FaCalendarAlt />
                                When
                              </div>
                            </Col>
                            <Col sm={9}>
                              <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Control type="date" placeholder="01/01/2024" value={travel_date}
                                  onChange={(e) => setFlightDate(e.target.value)} />
                              </Form.Group>
                            </Col>
                            <Col sm={3}>
                              <div className="svgicn mb-3 mb-md-0">
                                <BsFillSuitcase2Fill />
                                Max Weight, kg*
                              </div>
                            </Col>
                            <Col sm={7}>
                              <Form.Group controlId="formBasicEmail">
                                <Form.Control type="number" placeholder="Enter weight here" value={maxWeight}
                                  onChange={(e) => setMaxWeight(e.target.value)} />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="mt-3 mt-md-0">

                              <Dropdown
                                id="dropdown-basic"
                                className="drop-kg checkDrop"
                              >
                                Kg
                              </Dropdown>


                            </Col>
                          </Row>
                          <Row className="justify-content-center">
                            <Col xs={3}>
                              <Button className="last-btn c-btn mt-5" type="submit"
                                onClick={handleSubmit}
                              >
                                Save
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                    <Row className="gy-4 pt-5">
                      <h3 className="text-center">Upcoming Traveling List</h3>
                      {senderAndTravelerInfo.slice(0, itemsToShow).map((data, index) => (
                        <Col md={6}>
                          <Card>
                            <Card.Body>
                              <div className="crdbdymn">
                                <FaRegEdit className="edit-icon" onClick={() => {
                                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                                  setEditData(data);
                                }} />
                                {/* <p className="gray-color">{formatDate(data.created_at)}</p> */}
                                <div className="row">
                                  <Col xs={6} className="pe-md-0 d-flex">
                                    <div className="mncrd">
                                      <div className="crdhdr">
                                        <PiAirplaneTakeoffFill />
                                        From
                                      </div>
                                      <div className="crdbdy">

                                        <p>
                                          {data.fromWhere}
                                        </p>

                                        <div className="crdftr">

                                          {(data.from_state_name)}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col xs={6} className="d-flex">
                                    <div className="mncrd">
                                      <div className="crdhdr">
                                        <PiAirplaneLandingFill />
                                        To
                                      </div>
                                      <div className="crdbdy">
                                        <p>{data.toWhere}</p>
                                        <div className="crdftr">

                                          {(data.to_state_name)}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                </div>
                              </div>

                              <div className="ftrdv mb-4">
                                <FaCalendarAlt />
                                Travel Date: <span>{formatDateByMonth(data.travel_date)}</span>
                              </div>
                              <div className="ftrdvdwn mb-4">
                                <BsFillSuitcase2Fill />
                                Max Parcel Weight: <span>{data.maxWeight} Kg</span>
                              </div>

                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                      {itemsToShow < travelerInfoData.length && (
                        <div className="d-flex align-items-center justify-content-center mt-5">
                          <button className="view-btn" onClick={handleLoadMore}>
                            <RxDoubleArrowDown />
                            Load More
                          </button>
                        </div>
                      )}
                    </Row>
                  </Tab.Pane>

                </Tab.Content>


              </Col>
            </Row>
          </Tab.Container>

        </Container>
      </section>
    </>
  );
}

export default DashboardTraveler;
